"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScreenProps = void 0;
const core_1 = require("@bluebase/core");
const useScreenProps = () => {
    const BB = core_1.useBlueBase();
    const themes = core_1.useTheme();
    const intl = core_1.useIntl();
    return { BB, intl, themes, theme: themes.theme };
};
exports.useScreenProps = useScreenProps;
